import { render, staticRenderFns } from "./ListFamiliesAreas.vue?vue&type=template&id=3827f780"
import script from "./ListFamiliesAreas.vue?vue&type=script&lang=js"
export * from "./ListFamiliesAreas.vue?vue&type=script&lang=js"
import style0 from "./ListFamiliesAreas.vue?vue&type=style&index=0&id=3827f780&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3827f780')) {
      api.createRecord('3827f780', component.options)
    } else {
      api.reload('3827f780', component.options)
    }
    module.hot.accept("./ListFamiliesAreas.vue?vue&type=template&id=3827f780", function () {
      api.rerender('3827f780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/ListFamiliesAreas.vue"
export default component.exports